import { render, staticRenderFns } from "./editorlog.vue?vue&type=template&id=c23cbe68&scoped=true"
import script from "./editorlog.vue?vue&type=script&lang=js"
export * from "./editorlog.vue?vue&type=script&lang=js"
import style0 from "./editorlog.vue?vue&type=style&index=0&id=c23cbe68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23cbe68",
  null
  
)

export default component.exports